import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService } from "../../shared";
import { Core2Config } from '../../shared';
import { StockAdjustmentImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/inventory-transaction/stock-adjustment-import-file-helper.container.model';


@Injectable({
    providedIn: 'root'
})
export class StockAdjustmentImportFileHelperService extends BaseApiTemplateService<StockAdjustmentImportFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/helper/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/helper/backoffice-ep';
    this.httpClient = http;
  }

  async updateBackOfficeEp(containers: any[], visa: ApiVisa): Promise<any> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/helper/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'stock-adjustment/import-file-hdr/helper/backoffice-ep';
    }
    
    const headers = this.getHttpHeader(visa);
    
    return this.httpClient.put(url, containers, headers).toPromise();
  }

}